/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsLeftDown = createReactComponent("outline", "arrows-left-down", "IconArrowsLeftDown", [["path", { "d": "M7 3l-4 4l4 4", "key": "svg-0" }], ["path", { "d": "M3 7h11a3 3 0 0 1 3 3v11", "key": "svg-1" }], ["path", { "d": "M13 17l4 4l4 -4", "key": "svg-2" }]]);

export { IconArrowsLeftDown as default };
//# sourceMappingURL=IconArrowsLeftDown.mjs.map
